$(document).ready(function () {
  if (checkIfExists('.product-detail') || checkIfExists('.product-detail-new')) {
      // Create the main slider.
      



      // if (checkIfExists('#related-products-modal')) {
      // 
      //   var relatedSliderModal = new Splide( '#related-products-modal', {
      //     perPage: 5,
      //     rewind: true,
      //     isNavigation: true,
      //     arrows: false,
      //     gap: 7,
      //     lazyLoad: 'nearby',
      //     preloadPages: 2,
      //     start: 0,
      //     trimSpace: true,
      //     pagination: true,
      //     breakpoints: {
      //       '992': {
      //         perPage: 3
      //       },
      //       '500': {
      //         perPage: 2
      //       },
      //     }
      //   }).mount();
      // }



    $('.custom-select-vmz').change(function () {
      let val = $(this).find('select').val()
      if ($(this).hasClass('select-color')) {
        productSyncSelected(val, 'select-color')
      } else if($(this).hasClass('select-size')) {
        productSyncSelected(val, 'select-size')
      }
    });
    
    $('.video-thumbnail, .splide__arrow--next').on('click', function(){
      var video_id = $('.load-video-box').data('video-id');
      
      if ($('.embed-responsive').length == 0 && $('.video-thumbnail').length > 0) {
        $('.load-video-box').html('<div class="embed-responsive embed-responsive-16by9 embed-box" style="height: 100%"><iframe class="embed-responsive-item" src="//www.youtube.com/embed/'+video_id+'" height="100%"></iframe></div>');        
      }
    })
    
    $('.play-video').on('click', function(){
      var video_id = $('.load-video-box').data('video-id');
      
      if ($('.embed-responsive').length == 0 && $('.video-thumbnail').length > 0) {
        $('.load-video-box').html('<div class="embed-responsive embed-responsive-16by9 embed-box" style="height: 100%"><iframe class="embed-responsive-item" src="//www.youtube.com/embed/'+video_id+'" height="100%"></iframe></div>');        
        var index = $('.splide__list li').index($('.load-video-box'));
        primarySlider.go(index);
        
        $('html, body').animate({
          scrollTop: $(".load-video-box").offset().top
        }, 1000);
      }
      if ($('.embed-responsive').length > 0) {
        $('html, body').animate({
          scrollTop: $(".load-video-box").offset().top
        }, 1000);
      }
    })
    
    // $(document).ready(function(){
    // 
    // 
    // })

    if(checkIfExists('.btn-leasing')){
      $('.btn-leasing').on('click', function(e){
        e.preventDefault();
        $('.overlay').css('z-index', '10');
        $('.overlay').fadeIn('fast');
        $('#product-leasing').addClass('open')
      });

      $('.close-leasing').on('click', function(e){
        e.preventDefault();
        $('#product-leasing').removeClass('open');
  $('.overlay').fadeOut('fast');
  $('.overlay').css('z-index', '');
      })
    }


  }

  if (checkIfExists('#product-form')) {
    $('#product-form .color-select').on('change', function(){
    //   productColorChange();
      photoColorChange(primarySlider);
      
      productColorChangeNew();
    });

    $(document).on('click','.size-label', function(){
        $('.size-label').removeClass('active');
        $(this).addClass('active');
    })
    
    $('#product-form .size-select').on('change', function(){
      var quantity = $('#product-form .size-select option:selected').data('qty');
      
      if(quantity < 5){
        $('.storage-quantity').html(quantity);
        $('.alert-low-qty').removeClass('d-none');
      }else{
        $('.alert-low-qty').addClass('d-none');
      }
    });

    var product_id = $('#product-form input[name=product_id]').val();
    var csrf = $('#product-form input[name=_token]').val();

    $('#product-form').on('submit', function(e){
      e.preventDefault();
      $('#cart-messages').html('');
      var color_id = $('#product-form select[name=color_id] option:selected').val();
      var color_text = $('#product-form select[name=color_id] option:selected').text();
    //   var size_id = $('#product-form select[name=size_id] option:selected').val();
    //   var size_text = $('#product-form select[name=size_id] option:selected').text();
    var size_id = $('#product-form input[name=size_id]:checked').val();
      var size_text = $('#product-form input[name=size_id]:checked').parent().text();
      var quantity = $('#product-form input[name=quantity]').val();
      var fb_add_to_cart_id = $('#product-form input[name=fb_add_to_cart_id]').val();
      var data_form = {
        product_id: product_id,
        color_id: color_id,
        size_id: size_id,
        quantity: quantity,
        fb_add_to_cart_id: fb_add_to_cart_id,
        _token: csrf
      }

      $.ajax({
        url: $(this).attr('action'),
        dataType: 'json',
        type: 'post',
        data: data_form,
        success: function(data){
          $('.quick-cart-items').html(data.cart_view);
          $('.quick-cart .counter').html(data.count_products);

          if (data.code == 'ok') {
            $('#modal-product-added').modal('show');
            $('#modal-product-added .cart_counter').text(data.count_products);
            $('#modal-product-added .free-shipping-info').html(data.free_shipping);
            setTimeout(function(){
              $('#modal-product-added').modal('show');
              // relatedSliderModal.emit( 'resize' );
              
              fbq('track', 'AddToCart', {
                  content_name: `${data.product.title}`,
                  content_ids: [`${data.product.id}`],
                  content_type: 'product',
                  value: `${data.product.price}`,
                  currency: `${data.product.currency}`
                }, {eventID: `${data.product.add2cart_id}`});
            }, 200);
            setTimeout(function(){
              $('.color-title').text(color_text);
              $('.size-title').text(size_text);
              $('#modal-product-added .similar-products').css('opacity', 1);

            }, 300)
          }else{
            $('#cart-messages').html(data.text);
          }

        }
      })
    });


  }



  if (checkIfExists('#quick-order-form')) {
    $('#quick-order-form .color-select').on('change', function(){
      quickOrderColorChange();
    });

    var product_id = $('#quick-order-form input[name=product_id]').val();
    var csrf = $('#quick-order-form input[name=_token]').val();

    $(document).on('submit', '#quick-order-form', function(e){
      e.preventDefault();
      $('.error-message').remove();

      var color_id = $('#quick-order-form input[name=color_id]').val();
      var size_id = $('#quick-order-form input[name=size_id]').val();
      var email = $('#quick-order-form input[name=email]').val();
      var phone = $('#quick-order-form input[name=phone]').val();
      var terms = $('#quick-order-form input[name=terms]:checked').val();
      var quantity = $('#quick-order-form input[name=quantity]').val();

      var data_form = {
        product_id: product_id,
        email: email,
        phone: phone,
        color_id: color_id,
        size_id: size_id,
        quantity: quantity,
        terms: terms,
        _token: csrf
      }

      $('.btn-quick-order').addClass('d-none');

      $.ajax({
        url: $(this).attr('action'),
        dataType: 'json',
        type: 'post',
        data: data_form,
        success: function(data){
          if (data.code == 'error') {
            $('.btn-quick-order').removeClass('d-none');
            $.each(data.fields, function(key, value){
              const error = `<span class="text-danger error-message">${value}</span>`;
              if (key != 'terms') {
                $('#quick-order-form input[name='+key+']').after(error)
              }else{
                $('#quick-order-form label[for='+key+'_check_order]').after(error)
              }
            })
          }
          else if (data.code == 'error_option') {
            $('#undefined-color-size').html(data.error);
            $('.btn-quick-order').removeClass('d-none');
          }
          else if (data.code == 'error_quantity') {
            $('#quantity-error').html(data.error);
            $('.btn-quick-order').removeClass('d-none');
          }
          else{
            $('#order-success').html(data.message);
            setTimeout(function(){
              $('#undefined-color-size').html('');
              $('#quantity-error').html('');
              window.location.href = data.url;
            }, 2000);
          }
        }
      })
    });


  }



  $(document).on('submit', '.cart-remove', function(e){
    e.preventDefault();
    var hasRefresh = $(this).data('refresh');
    $.ajax({
      url: $(this).attr('action'),
      data: $(this).serialize(),
      dataType: 'json',
      type: 'delete',
      success: function(data){
        $('.quick-cart-items').html(data.cart_view);
        $('.quick-cart .counter').html(data.count_products);
        if (hasRefresh == 'yes') {
          location.reload();
        }
      }
    })
  })
})

if (checkIfExists('.product-detail') || checkIfExists('.product-detail-new')) {

  $(document).ready(function(){
    var checkColorSizes = $('.color-select').children('option').length;
  
  if(checkColorSizes == 2){
    //   $('.color-select').first('option').prop('disabled', true);
    //   $('.color-select').last('option').prop('selected', true);
      setTimeout(function(){
        let colorVal = $('.color-select option:last').val();
        $('.color-select option:first').attr('disabled', true);
        $('.color-select').val(colorVal);
        $('.color-select').trigger('change');
      }, 500);
  }
  })


  $('.btn-number').click(function(e){
    e.preventDefault();

    fieldName = $(this).attr('data-field');
    type      = $(this).attr('data-type');
    var input = $("input[name='"+fieldName+"']");
    var currentVal = parseInt(input.val());
    var price = $('.price-text').data('price');
    var currency = $('.price-text').data('currency');
    var country = $('.price-text').data('country');
    var action = $('.price-text').data('action');
    var shipping_action = $('.price-text').data('shipping-action');

    if (!isNaN(currentVal)) {
      if(type == 'minus') {
        if(currentVal > input.attr('min')) {
          input.val(currentVal - 1).change();
          $('#quick-order-form #quantity').val(currentVal - 1)
          $('#quick-order-form .quantity-text .quantity').text(currentVal - 1)

          var quantity = currentVal - 1;
          console.log(quantity + 'x' + price);
        }
        if(parseInt(input.val()) == input.attr('min')) {
          $(this).attr('disabled', true);
        }

      } else if(type == 'plus') {

        if(currentVal < input.attr('max')) {
          input.val(currentVal + 1).change();
          $('#quick-order-form .quantity-text .quantity').text(currentVal + 1)
          var quantity = currentVal + 1;
          console.log(quantity + 'x' + price);
        }
        if(parseInt(input.val()) == input.attr('max')) {
          $(this).attr('disabled', true);
        }

      }

      var csrf = $('meta[name="csrf-token"]').attr('content');
      data = {
        _token: csrf,
        type: type,
        quantity: quantity,
        price: price,
        currency: currency,
        country: country,
      }
      $.ajax({
        url: action,
        type: 'post',
        data: data,
        success: function(data){
          $('.price-text').html(data.total_price);
          $('.shipping-text').html(data.shipping_price);
          $('.total-price-text').html(data.grand_total);
          // $('.prices-wrapper .price').html(data);
        }
      })



    } else {
      input.val(0);
    }
  });

  $('.input-number').focusin(function(){
    $(this).data('oldValue', $(this).val());
    $('#quick-order-form #quantity').val($(this).val())
    $('#quick-order-form .quantity-text .quantity').text($(this).val())
  });

  $('.input-number').change(function() {
    minValue =  parseInt($(this).attr('min'));
    maxValue =  parseInt($(this).attr('max'));
    valueCurrent = parseInt($(this).val());

    name = $(this).attr('name');
    if(valueCurrent >= minValue) {
      $(".btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
    } else {
      alert('Sorry, the minimum value was reached');
      $(this).val($(this).data('oldValue'));
      $('#quick-order-form #quantity').val($(this).data('oldValue'))
      $('#quick-order-form .quantity-text .quantity').text($(this).data('oldValue'))
    }
    if(valueCurrent <= maxValue) {
      $(".btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
    } else {
      alert('Sorry, the maximum value was reached');
      $(this).val($(this).data('oldValue'));
      $('#quick-order-form #quantity').val($(this).data('oldValue'))
      $('#quick-order-form .quantity-text .quantity').text($(this).data('oldValue'))
    }


  });
  $(".input-number").keydown(function (e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
    // Allow: Ctrl+A
    (e.keyCode == 65 && e.ctrlKey === true) ||
    // Allow: home, end, left, right
    (e.keyCode >= 35 && e.keyCode <= 39)) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  });
}
